import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css'
// 使用自定义element主题
import '../theme/index.css'
Vue.use(ElementUI)


/* 引用vant的弹窗组件 */
import {
	Toast,
	Dialog,
	Tag
} from 'vant';
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Tag);
import 'vant/lib/toast/style';
import 'vant/lib/dialog/style';
import 'vant/lib/tag/style';


// 引入 dayjs
import dayjs from 'dayjs'
Vue.prototype.dayjs = dayjs;


// 导入全局样式
import './styles/theme.css'



import {
	post1,
	post2
} from './utils/request.js'
Vue.prototype.service1 = post1;
Vue.prototype.service2 = post2;

// 授权登录
Vue.prototype.mpLogin = function() {
	console.log(this.pageUrl())
	return new Promise((resolve, reject) => {
		//判断是否是微信
		let isWeixin = navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == "micromessenger";
		if (!isWeixin || this.$store.getters.code) {
			console.log('无需登录')
			resolve();
		} else {
		}
	})
}
// 页面路径
Vue.prototype.pageUrl = function() {
	let domain = window.location.origin;
	let mode = this.$router.mode == 'hash' ? '#' : ''

	let path = this.$route.path;
	let query = this.$route.query
	let params = Object.keys(query).map(function(key) {
		return encodeURIComponent(key) + "=" + encodeURIComponent(query[key]);
	}).join("&");

	params = params ? '?' + params : ''
	return domain + mode + path + params;
}
Vue.config.productionTip = false

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
